import React, { Component } from "react";
import {Row, Col, container, Table} from "react-bootstrap";
import ReactPlayer from "react-player";
import './audioplay.css';


import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import PropTypes from "prop-types";


// import Male Audio Samples
import audiom1 from "../../../assets/sampleDatasets/MagadhiMale/Magadhi_agri_m.wav";
import audiom2 from "../../../assets/sampleDatasets/MagadhiMale/Magadhi_book_m.wav";
import audiom3 from "../../../assets/sampleDatasets/MagadhiMale/Magadhi_health_m.wav";


function Magadhi_Male(){
    return( 
    <div className="container">
        <table>
            {/* Table Heading */}
            <thead>
            <tr>
                <th className="headTable">Audio</th>
                <th className="headTable">Text</th>
            </tr>
            </thead>
            <tbody>
            <tr> {/* Table Row Sample 1 */}
                <td className="tableEvenRow"><ReactPlayer   
                        url={audiom1}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing "> प्रमुख कृषि वैज्ञानिक हलथिन रॉबर्ट बेकबेल लूथर बरबैंक जॉर्ज वाशिंगटन कार्वर कार्ल हेनरी क्लर्क जॉर्ज सी क्लर्क रेने ड्यूमॉन्ट सर अल्बर्ट हॉवर्ड </p></td>
            </tr>
            <tr> {/* Table Row Sample 2 */}
                    <td className="tableOddRow"><ReactPlayer   
                        url={audiom2}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableOddRow"><p className="p-medium-line-spacing">प्रकाशक  मगधांचल पब्लिकेशन पचरुखिया मोड़, औरंगाबाद  प्रोफेसर. अलखदेव प्रसाद 'अचल' एगो क्रांतिदर्शी लेखक हथ ।</p></td>
            </tr>
            <tr> {/* Table Row Sample 3 */}
                    <td className="tableEvenRow"><ReactPlayer   
                        url={audiom3}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">चिकित्सा बिलिंग युनाइटेड स्टेट्स हेल्थ सिस्टम के भीतर एगो भुगतान रीती हई</p></td>
            </tr>
            </tbody>
        </table>


    </div>

    );
}

const Sample_Magadhi_Male = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
            <RenderPage
                id="tst-landing"
                className={`render px-0 ${props.isClassName ? 'render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            > 
                <SEOComponent
                    title="SampleMagadhiMale"
                    keywords="Speech Recognition, respin, SPIRE LAB, Navana"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/SampleMagadhiMale" />
                   
                    <Strip
                        id="tst-SampleDatasets"
                        className="strip strip-no-padding px-20"
                        containerType="container"
                    >
                   

                    <div className="mx-0  pt-5">  
                        <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Sample Magadhi Male Audio</h5>
                            <div className="mx-0 mb-5 pb-5">
                                <Magadhi_Male />
                            </div>
                    </div>

</Strip>
</RenderPage>
</ExternalLayout>
);
};

export default Sample_Magadhi_Male;